import { tv } from '~/utils/tv'

export const InputMultiSelectRootStyles = tv({
  base: 'flex w-full min-w-[calc(var(--sizing-gigantic)_+_var(--sizing-gigantic))] flex-col gap-halfpulse',
  variants: {
    disabled: {
      true: 'opacity-50',
    },
    readonly: {
      true: 'opacity-75',
    },
  },
})
